// Hero Slideshow JavaScript
document.addEventListener('DOMContentLoaded', function() {
  const slideshow = document.getElementById('heroSlides');
  if (!slideshow) return;

  const slides = Array.from(slideshow.querySelectorAll('.hero-slide')).filter(slide => !slide.classList.contains('empty'));
  if (slides.length === 0) return;

  let currentSlide = 0;
  const duration = parseInt(slideshow.closest('.hero-slideshow').dataset.slideDuration, 10) || 7;

  // Set initial slide visible
  slides[currentSlide].classList.add('active');

  // Rotate slides
  setInterval(() => {
    slides[currentSlide].classList.remove('active');
    currentSlide = (currentSlide + 1) % slides.length;
    slides[currentSlide].classList.add('active');
  }, duration * 1000);
}); 